import { render, staticRenderFns } from "./FunctionGroup.vue?vue&type=template&id=0478404a&scoped=true&"
import script from "./FunctionGroup.vue?vue&type=script&lang=ts&"
export * from "./FunctionGroup.vue?vue&type=script&lang=ts&"
import style0 from "./FunctionGroup.vue?vue&type=style&index=0&id=0478404a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0478404a",
  null
  
)

export default component.exports